export const ConvertDate = (date, lang) =>{
    const monthNames = (lang == 'en') ? 
    ["January", "February", "March", "April", "May", "June","July", "August", "September", "October", "November", "December"]
        :
    ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio","Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    let _date=new Date(String(date).replace(/-/g, '\/'))
    return(`${_date.getDate()} ${monthNames[_date.getMonth()]} ${_date.getFullYear()}`);
}